module.exports = __webpack_public_path__ + "img/side-ewm2.77f6c412.png";